import React, { useEffect, useState } from 'react';
import { DatabaseTable } from '@customtypes/parsedLesson';
import { TOOLTIP_DELAY_SHOW } from '@utils/constants';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { DefaultTooltip } from '@utils/tooltip-utils';
import EyeOpenIconComponent from './icons/eyeOpenIcon';
import EyeCloseIconComponent from './icons/eyeClosedIcon';
import { medium_xs } from './web/texts/Styles';

const DATABASE_SOURCE_OR_SOLUTION_TOOLTIP_ID =
  'database-source-or-solution-tooltip';

export function DatabaseSourceOrSolutionComponent({
  tables,
  solutionTable,
  isSolution = true,
}: {
  tables: DatabaseTable[];
  solutionTable?: DatabaseTable;
  isSolution?: boolean;
}) {
  const [showExpectedResult, setShowExpectedResult] = useState(false);
  const [selectedTable, setSelectedTable] = useState(tables[0]);

  useEffect(() => {
    if (showExpectedResult && solutionTable) {
      setSelectedTable(solutionTable);
    } else {
      setSelectedTable(tables[0]);
    }
  }, [showExpectedResult]);

  return (
    <>
      <ReactTooltip
        className="defaultTooltip"
        id={DATABASE_SOURCE_OR_SOLUTION_TOOLTIP_ID}
        noArrow
        opacity={1}
        delayShow={TOOLTIP_DELAY_SHOW}
      ></ReactTooltip>
      <div className="relative flex h-full w-full flex-col overflow-hidden rounded-xl border border-product2-border-secondary">
        <header className="flex h-10 flex-shrink-0 bg-product2-background-primary">
          <div className="custom-scrollbar flex h-full flex-grow overflow-x-auto ">
            {showExpectedResult || !isSolution ? (
              <div
                className={`flex items-center whitespace-pre border-b border-solid border-product2-border-secondary px-3 ${medium_xs}`}
              >
                Expected Result
              </div>
            ) : (
              <>
                {tables.map((table, index) => (
                  <button
                    key={index}
                    className={`flex cursor-pointer items-center whitespace-pre border-b border-solid px-3 text-xs font-semibold
                  ${
                    table.name === selectedTable.name
                      ? 'border-product2-border-accentLight text-product2-content-primary'
                      : `border-product2-border-secondary
                      text-product2-content-secondary
                      hover:text-product2-content-primary`
                  }
              `}
                    onClick={() => setSelectedTable(table)}
                  >
                    {table.name}
                  </button>
                ))}
              </>
            )}
            <div className="flex-grow border-b border-product2-border-secondary"></div>
          </div>
          <div className="flex items-center justify-center border-b border-product2-border-secondary pr-1">
            {solutionTable ? (
              <button
                onClick={() => setShowExpectedResult(!showExpectedResult)}
                className="flex h-8 w-8 items-center justify-center rounded-lg hover:bg-product2-background-tertiary"
                data-tooltip-id={DATABASE_SOURCE_OR_SOLUTION_TOOLTIP_ID}
                data-tooltip-html={
                  showExpectedResult
                    ? DefaultTooltip('Hide expected result')
                    : DefaultTooltip('Show expected result')
                }
              >
                {showExpectedResult ? (
                  <EyeCloseIconComponent className="h-4 w-4 flex-shrink-0" />
                ) : (
                  <EyeOpenIconComponent className="h-4 w-4 flex-shrink-0" />
                )}
              </button>
            ) : null}
          </div>
        </header>
        <div className="mx-[-1px] mb-[-1px] max-h-52 overflow-x-auto">
          <table className="w-full border-collapse bg-product-background-secondary-dark text-xs text-product-text-primary-dark">
            <tbody>
              {selectedTable ? (
                selectedTable.rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.tableCells.map((cell, cellIndex) =>
                      cell.cellType === 'Header' ? (
                        <th
                          key={cellIndex}
                          className={`h-9 border-collapse border border-solid border-product2-border-secondary px-3 text-left align-middle font-bold
                    ${rowIndex === 0 ? 'border-t-0' : ''}
                    `}
                        >
                          {cell.content}
                        </th>
                      ) : (
                        <td
                          key={cellIndex}
                          className={`h-9 border-collapse border border-solid border-product2-border-secondary bg-product2-background-primary px-3 align-middle`}
                        >
                          {cell.content}
                        </td>
                      ),
                    )}
                  </tr>
                ))
              ) : (
                <tr className="flex h-10 items-center justify-center">
                  <td>Empty database module</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
